import { api } from "@/lib/api";

const VOICE_MAX_IN_FLIGHT = 4;
const VOICE_TIMEOUT_MS = 3000;
const voiceRequests = new Map();

function finishVoiceRequest(entry) {
  if (entry.timer) clearTimeout(entry.timer);
  voiceRequests.delete(entry);
}

export function cancelVoiceTelemetry(scope) {
  for (const entry of Array.from(voiceRequests.keys())) {
    if (entry.scope !== scope) continue;
    entry.controller?.abort();
    finishVoiceRequest(entry);
  }
}

export function track(type, properties, options = null) {
  if (type.startsWith("voice_") && options?.scope) {
    if (voiceRequests.size >= VOICE_MAX_IN_FLIGHT) {
      if (type !== "voice_closed") return;
      // Preserve the terminal observation without growing the queue: replace
      // the oldest pending sample when all slots are occupied.
      const oldest = voiceRequests.keys().next().value;
      oldest?.controller?.abort();
      if (oldest) finishVoiceRequest(oldest);
    }
    const controller = typeof AbortController === "function" ? new AbortController() : null;
    const entry = { scope: options.scope, controller, timer: null };
    voiceRequests.set(entry, true);
    entry.timer = setTimeout(() => {
      controller?.abort();
      finishVoiceRequest(entry);
    }, VOICE_TIMEOUT_MS);
    try {
      Promise.resolve(api.post(
        "/events",
        { type, properties: properties || null },
        controller ? { signal: controller.signal } : undefined,
      )).catch(() => {}).finally(() => finishVoiceRequest(entry));
    } catch {
      finishVoiceRequest(entry);
    }
    return;
  }
  try {
    api.post("/events", { type, properties: properties || null }).catch(() => {});
  } catch {
    /* telemetry never blocks the UI */
  }
}
